import { Link } from "gatsby";
import { IArticle } from "../../../interfaces/Article.interface";
import "./RelatedArticles.scss";

interface Props {
  data: IArticle[];
}

const RelatedArticles = ({ data }: Props) => {
  return (
    <div className="m-related-articles">
      <h2 tabIndex={0}>Artículos relacionados</h2>
      <ul>
        {data?.map(({ url, h2 }) => (
          <li key={url}>
            <div className="bullet" />
            <Link to={url} rel="noopener noreferrer">
              {h2}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedArticles;
